import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';

interface ProtectedRouteProps {
    adminOnly?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ adminOnly = false }) => {
    const { isAuthenticated, isLoading, isAdmin } = useContext(AuthContext)!;

    if (isLoading) {
        // 認証状態を確認中の場合、ローディングインジケーターなどを表示
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!isAuthenticated) {
        // 認証されていなければログインページにリダイレクト
        return <Navigate to="/login" replace />;
    }

    // adminOnlyがtrueの場合、isAdminもチェック
    if (adminOnly && !isAdmin) {
        // 管理者でない場合は、ホームページなどにリダイレクト
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
